"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This enum is in sync with the GI domain model
var OffsetUnit;
(function (OffsetUnit) {
    OffsetUnit["DAYS"] = "calendar_day";
    OffsetUnit["WORKDAYS"] = "working_day";
    OffsetUnit["WEEKS"] = "week";
    OffsetUnit["MONTHS"] = "month";
    OffsetUnit["YEARS"] = "year";
})(OffsetUnit || (OffsetUnit = {}));
exports.default = OffsetUnit;
